var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H12.05C11.47 13 11 12.53 11 11.95V2H12C14.63 2 17.21 3.07 19.07 4.93C20.93 6.79 22 9.37 22 12V13ZM13 11H19.94C19.72 9.25 18.91 7.6 17.66 6.34C16.41 5.08 14.75 4.28 13 4.06V11Z",
    fill: "#767C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.48 14.9999C18.28 17.9199 15.41 19.9899 12.06 19.9899C7.63 19.9899 4.02 16.3799 4.02 11.9499C4.02 8.5999 6.09 5.7299 9.01 4.5299V2.3999C4.95 3.6899 2 7.4699 2 11.9499C2 17.4899 6.51 21.9999 12.05 21.9999C16.53 21.9999 20.31 19.0499 21.6 14.9999H19.47H19.48Z",
    fill: "#767C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestingIcon);
export default __webpack_public_path__ + "static/media/Investing_icon.995e3c5ede0546ce36c97b6a2c365034.svg";
export { ForwardRef as ReactComponent };